import {baseApi} from "./apiService";
import {LoginPayload} from "../types";

export type {LoginPayload};

export interface PasswordResetRequestPayload {
    email: string;
    // Customer accounts and barber accounts have separate request endpoints.
    customer?: boolean;
}

export interface PasswordResetCompletePayload {
    token: string;
    password: string;
}

export const authApi = baseApi.injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
        login: builder.mutation<void, LoginPayload>({
            query: (credentials) => ({
                url: 'login_check',
                method: 'POST',
                body: credentials,
            }),
        }),
        // POST /api/password-reset/request (barber) or
        // /api/customer/password-reset/request (customer). Always 2xx — never
        // reveals whether an account exists. Rate-limited on the BE.
        requestPasswordReset: builder.mutation<void, PasswordResetRequestPayload>({
            query: ({email, customer}) => ({
                url: customer ? 'customer/password-reset/request' : 'password-reset/request',
                method: 'POST',
                body: {email},
            }),
        }),
        // POST /api/password-reset/complete — { token, password }. 400
        // { error: 'invalid_token' | 'weak_password' } on failure.
        completePasswordReset: builder.mutation<void, PasswordResetCompletePayload>({
            query: (body) => ({
                url: 'password-reset/complete',
                method: 'POST',
                body,
            }),
        }),
    }),
})

export const {
    useLoginMutation,
    useRequestPasswordResetMutation,
    useCompletePasswordResetMutation,
} = authApi
